import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserEffectivePermissionsService } from 'src/app/features/service/user-effective-permissions.service';

export const effectivePermissionsGuard: CanActivateFn = (_route, state) => {
  const permissionsService = inject(UserEffectivePermissionsService);
  const router = inject(Router);

  if (!permissionsService.isEnforcementEnabled()) {
    return true;
  }

  if (permissionsService.isLoggedInSuperAdmin()) {
    return true;
  }

  const routeSegment =
    permissionsService.parseUrlPathSegments(state.url)[0] ?? '';
  if (!permissionsService.isEnforcedRoute(routeSegment)) {
    return true;
  }

  return permissionsService.waitUntilResolved().pipe(
    map(() => {
      if (permissionsService.isUrlPermitted(state.url)) {
        return true;
      }
      return router.createUrlTree(
        permissionsService.getAccessDeniedRedirect(routeSegment)
      );
    })
  );
};
